export default {
	tenantId: "yallacompare_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "yallacompare--uat"
	}
}
